import { render, staticRenderFns } from "./PasswordFieldWidget.vue?vue&type=template&id=2bd20ffb&"
import script from "./PasswordFieldWidget.vue?vue&type=script&lang=ts&"
export * from "./PasswordFieldWidget.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordFieldWidget.vue?vue&type=style&index=0&id=2bd20ffb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports